import { useState, useEffect, useCallback } from 'react';

const useCountdown = (targetDate) => {
    const calculateTimeLeft = useCallback(() => {
        if (!targetDate) {
            return {
                days: 0,
                hours: 0,
                minutes: 0,
                seconds: 0,
                formatted: 'No date provided',
                isPast: true,
            };
        }

        const target = new Date(targetDate);
        const now = new Date();
        const difference = target.getTime() - now.getTime();

        if (difference <= 0) {
            return {
                days: 0,
                hours: 0,
                minutes: 0,
                seconds: 0,
                formatted: 'Expired',
                isPast: true,
            };
        }

        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((difference % (1000 * 60)) / 1000);

        let formatted = '';
        if (days > 7) {
            formatted = `${days} days`;
        } else if (days > 0) {
            formatted = `${days}d ${hours.toString().padStart(2, '0')}h`;
        } else if (hours > 0) {
            formatted = `${hours.toString().padStart(2, '0')}h ${minutes
                .toString()
                .padStart(2, '0')}m`;
        } else if (minutes > 0) {
            formatted = `${minutes.toString().padStart(2, '0')}m ${seconds
                .toString()
                .padStart(2, '0')}s`;
        } else {
            formatted = `${seconds.toString().padStart(2, '0')}s`;
        }

        return {
            days,
            hours: hours.toString().padStart(2, '0'),
            minutes: minutes.toString().padStart(2, '0'),
            seconds: seconds.toString().padStart(2, '0'),
            formatted,
            isPast: false,
            totalSeconds: Math.floor(difference / 1000),
        };
    }, [targetDate]);

    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

    useEffect(() => {
        const timer = setInterval(() => {
            setTimeLeft(calculateTimeLeft());
        }, 1000);

        return () => clearInterval(timer);
    }, [targetDate, calculateTimeLeft]);

    return timeLeft;
};

export default useCountdown;
